var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRecoilState, useRecoilValue } from 'recoil';
import { useContext, useEffect, useState } from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { SpinnerButton, loadingSpinner } from './Ui/SpinnerButton/SpinnerButton';
import { Dropdown } from './Ui/Dropdown/Dropdown';
import { LanguageId } from './ProductCard';
import { appConfigState, appOrderState, appPaymentState, appProgressState, useProgress, useSetAppErrors, } from '../Domain/State/AppState';
import { AppServiceContext } from '../Domain/Context/AppServiceContext';
import { useTrackPageWithCustomDimensions } from '../Tracking';
export function PaymentSelection() {
    var _a;
    var _b = useState([]), paymentOptions = _b[0], setPaymentOptions = _b[1];
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useContext(AppServiceContext) || {}, orderService = _d.orderService, paymentService = _d.paymentService;
    var _e = useRecoilState(appOrderState), order = _e[0], setOrder = _e[1];
    var _f = useRecoilState(appPaymentState), paymentInformation = _f[0], setPaymentInformation = _f[1];
    var updateErrorMessage = useSetAppErrors().updateErrorMessage;
    var switching = useRecoilValue(appProgressState).switching;
    var _g = useProgress(), stepForward = _g.stepForward, stepBackward = _g.stepBackward, setSwitching = _g.setSwitching;
    var pushInstruction = useMatomo().pushInstruction;
    var trackingPrefix = useRecoilValue(appConfigState).trackingPrefix;
    useEffect(function () {
        setSwitching(false);
    }, []);
    useEffect(function () {
        var _a;
        var methodNameToPaymentIds = {};
        if (!switching && paymentService) {
            var promises = ((_a = order === null || order === void 0 ? void 0 : order.payments) !== null && _a !== void 0 ? _a : []).map(function (_a) {
                var _b;
                var id = _a.id, method = _a.method;
                methodNameToPaymentIds[(_b = method.name) !== null && _b !== void 0 ? _b : 'key'] = id;
                return paymentService.getPaymentMethods(id);
            });
            Promise.all(promises)
                .then(function (_a) {
                var methods = _a[0];
                methods.forEach(function (method) {
                    setPaymentOptions(function (prevState) {
                        var _a, _b;
                        return __spreadArray(__spreadArray([], prevState, true), [{
                                id: methodNameToPaymentIds[(_a = method.name) !== null && _a !== void 0 ? _a : 'key'],
                                method: method,
                                // eslint-disable-next-line max-len
                                translations: (_b = method.translations) !== null && _b !== void 0 ? _b : {},
                            },], false);
                    });
                });
            }).catch(function (error) {
                updateErrorMessage("Bitte kontaktieren Sie den Webseiten-Support. Fehler: ".concat(error.message));
            }).finally(function () {
                setIsLoading(false);
            });
        }
    }, [order, paymentService, switching]);
    function handleSelect(value) {
        if (typeof value === 'function') {
            return;
        }
        var paymentId = parseInt(value.substring(value.indexOf('id') + 'id-'.length, value.indexOf('-method')), 10);
        var paymentMethodCode = value.substring(value.indexOf('-method') + '-method-'.length);
        var translatedOption = paymentOptions.filter(function (item) { return (item.id === paymentId && item.method); })[0].translations[LanguageId.de].description;
        setPaymentInformation({
            selectedValue: value,
            paymentId: paymentId,
            paymentMethodCode: paymentMethodCode,
            translation: translatedOption,
        });
    }
    function handleClick() {
        return __awaiter(this, void 0, void 0, function () {
            var form;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form = document.getElementById("".concat(trackingPrefix, "-payment-selection-step"));
                        pushInstruction('FormAnalytics::trackForm', form);
                        setSwitching(true);
                        if (!(orderService
                            && (order === null || order === void 0 ? void 0 : order.tokenValue)
                            && paymentInformation.paymentId
                            && paymentInformation.paymentMethodCode)) return [3 /*break*/, 2];
                        setSwitching(true);
                        return [4 /*yield*/, orderService.setPaymentMethod(order.tokenValue, paymentInformation.paymentId, paymentInformation.paymentMethodCode, setOrder)
                                .then(function (updatedOrder) {
                                if (updatedOrder
                                    && Object.keys(updatedOrder).includes('statusCode')
                                    && Object.keys(updatedOrder).includes('message')) {
                                    updateErrorMessage("Bitte kontaktieren Sie den Webseiten-Support. Fehler: ".concat(updatedOrder.statusCode, " ").concat(updatedOrder.message));
                                }
                                else {
                                    pushInstruction('FormAnalytics::trackFormSubmit', form);
                                    stepForward();
                                }
                            })
                                .catch(function () {
                                setSwitching(false);
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    useTrackPageWithCustomDimensions();
    return (_jsxs(_Fragment, { children: [_jsx("form", __assign({ className: "form-page", id: "".concat(trackingPrefix, "-payment-selection-step") }, { children: _jsxs("div", __assign({ className: "fields row" }, { children: [_jsxs("div", __assign({ className: "field field--text col col-12 col-md-12" }, { children: [_jsx("label", { children: "Bitte w\u00E4hlen Sie eine Zahlungsm\u00F6glichkeit" }), _jsx("div", { className: "field__text" })] })), isLoading ? loadingSpinner({ class: 'blue' })
                            : _jsx(Dropdown, { fieldName: "payment-selection", label: "Zahlungsm\u00F6glichkeiten", options: paymentOptions, value: (_a = paymentInformation.selectedValue) !== null && _a !== void 0 ? _a : '', languageCode: LanguageId.de, required: true, setSelectedValue: handleSelect })] })) })), _jsx("div", __assign({ className: "actions" }, { children: _jsx("nav", __assign({ className: "form-navigation" }, { children: _jsxs("ul", { children: [_jsx("li", __assign({ className: "previous" }, { children: _jsx(SpinnerButton, { caption: "zur\u00FCck", type: "button", clickHandler: stepBackward, isDisabled: switching, secondary: true }) })), _jsx("li", __assign({ className: "next" }, { children: _jsx(SpinnerButton, { type: "button", caption: "weiter", isLoading: switching, isDisabled: !paymentInformation.paymentId
                                        && !paymentInformation.paymentMethodCode, clickHandler: handleClick }) }))] }) })) }))] }));
}
